<script>
  import { apiFetch } from "../lib/api.js";
  import { user } from "../stores/user"
  import { navigate } from "svelte-routing"
  import { BASE_URL } from "../stores/BASE_URL"

  let email = ""
  let password = ""

  let data_user = {
    user: undefined,
    message: undefined,
    loading: false,
  }

  const login = async () => {
    if (!email.trim() || !password.trim()) {
      console.log("Campos vacios")
      return
    }

    data_user.loading = true
    let formData = new FormData()
    formData.append("usuario", email)
    formData.append("clave", password)

    let url = `${BASE_URL}/session.php`
    const response = await apiFetch(url, {
      method: "POST",
      body: formData,
    })

    const resp = await response.json()

    data_user = {
      user: resp.data,
      loading: false,
    }

    if (resp.status === "success") {
      user.setUser(data_user.user)
      navigate("/usuarios", {
        replace: true,
      })
    } else {
      data_user.message = resp.message
    }
  }
</script>

<div
  class="text-center vh-100 d-flex justify-content-center align-items-center"
>
  <form
    on:submit|preventDefault={login}
    class="p-5 bg-white text-secondary card-outline shadow-sm rounded"
  >
    <div class="d-flex flex-row mb-5 text-secondary">
      <div class="text-end border-secondary pe-2 border-end">
        <p
          class="p-0 m-0 lh-1 fs-5 navbar-brand"
          style="font-family: 'Raleway', sans-serif;"
        >
          DomaDesk
        </p>
        <p
          class="p-0 m-0 lh-1 fs-5 navbar-brand"
          style="font-family: 'Raleway', sans-serif;"
        >
          IAM
        </p>
      </div>
      <div class="d-flex align-items-center">
        <p
          class="m-0 ps-2 navbar-brand"
          style="font-family: 'Raleway', sans-serif; font-size: 11px;"
        >
          Identity & Access Management
        </p>
      </div>
    </div>

    <input
      class="form-control mb-2"
      type="text"
      placeholder="Ingrese su usuario"
      bind:value={email}
    />
    <input
      class="form-control mb-2"
      type="password"
      placeholder="Ingrese su contraseña"
      bind:value={password}
    />

    {#if data_user.loading}
      <button
        class="form-control btn btn-primary disabled"
        type="submit"
        disabled
      >
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        />
        Inciando Sesión...
      </button>
    {:else}
      <button class="form-control btn btn-primary" type="submit">
        Ingresar
      </button>
    {/if}

    {#if data_user.message !== undefined}
      <div
        class="alert {data_user.message !== 'Bienvenido'
          ? 'alert-danger'
          : 'alert-success'} mt-2"
        role="alert"
      >
        {data_user.message}
      </div>
    {/if}
  </form>
</div>

<style>
</style>
